import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Settings } from "lucide-react";
import { Modal } from "./bits";

export default function Ticker() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [all, setAll] = useState([]);
  const [sel, setSel] = useState([]);
  const load = () => api.get("/market/ticker").then((r) => { setD(r.data); setSel(r.data.watchlist || []); }).catch(() => {});
  useEffect(() => { load(); const i = setInterval(load, 60000); return () => clearInterval(i); }, []);
  const openSettings = async () => { const { data } = await api.get("/market/ticker/symbols"); setAll(data); setOpen(true); };
  const save = async () => { await api.put("/market/watchlist", { symbols: sel }); setOpen(false); load(); };
  const toggle = (s) => setSel((x) => (x.includes(s) ? x.filter((y) => y !== s) : [...x, s]));
  if (!d?.items?.length) return null;
  const fmt = (p) => (p >= 1000 ? p.toLocaleString(undefined, { maximumFractionDigits: 2 }) : p >= 10 ? p.toFixed(2) : p.toFixed(4));
  const items = [...d.items, ...d.items];
  return (
    <div className="ticker" data-testid="ticker-banner">
      <div className="ticker-track" style={{ animationDuration: `${d.items.length * 4}s` }}>
        {items.map((it, i) => <span key={i} className="ticker-item" data-testid={i < d.items.length ? `ticker-${it.symbol}` : undefined}>
          <b>{it.symbol}</b><span className="mono">{fmt(it.price)}</span>{it.delayed && <span className="sub" style={{ fontSize: ".6rem" }} title={it.source}>delayed</span>}
          {it.change_pct != null && <span className={`mono ${it.change_pct >= 0 ? "pos" : "neg"}`}>{it.change_pct >= 0 ? "▲" : "▼"} {Math.abs(it.change_pct).toFixed(2)}%</span>}
        </span>)}
      </div>
      <button className="ticker-gear" onClick={openSettings} title="Choose ticker symbols" data-testid="ticker-settings-btn"><Settings size={13} /></button>
      <Modal open={open} onClose={() => setOpen(false)} title="Your ticker watchlist" testId="watchlist-modal">
        <div className="sub">Pick the symbols that scroll across your banner. Leave all unticked to show everything.</div>
        <div className="flex gap-2 flex-wrap mt-3">{all.map((s) => <button key={s.symbol} className={`tag ${sel.includes(s.symbol) ? "ok" : ""}`} onClick={() => toggle(s.symbol)} data-testid={`watch-${s.symbol}`}>{s.symbol} <span style={{ opacity: .6 }}>· {s.asset_class}</span></button>)}</div>
        <div className="pill-row"><button className="btn" onClick={save} data-testid="watchlist-save-btn">Save watchlist</button><button className="btn ghost" onClick={() => setSel([])}>Clear</button></div>
      </Modal>
    </div>
  );
}
